import { render, staticRenderFns } from "./checkout-review.vue?vue&type=template&id=51b34a87&scoped=true&"
import script from "./checkout-review.vue?vue&type=script&lang=js&"
export * from "./checkout-review.vue?vue&type=script&lang=js&"
import style0 from "./checkout-review.vue?vue&type=style&index=0&id=51b34a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b34a87",
  null
  
)

export default component.exports